import { render, staticRenderFns } from "./OrderActionCapturePayment.vue?vue&type=template&id=10bdc75a&"
import script from "./OrderActionCapturePayment.vue?vue&type=script&lang=ts&"
export * from "./OrderActionCapturePayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports